module.exports = __webpack_public_path__ + "img/IHK.74e064e3.png";